import type { DirectDebit } from './DirectDebit';

export const base: DirectDebit = {
    enabled: false,
    _description: 'Enables direct debit product',
    useFocusPage: {
        enabled: false,
        _description: 'Show detail in focus page',
    },
    createNewContact: {
        enabled: false,
        _description: 'Creates new contact in AB after submitting Direct Debit Approval',
    },
};
